'use client';

import { createContext, useContext, useState, ReactNode } from 'react';
import EstablishConnectionModal from '@/components/modals/EstablishConnectionModal';
import ClosePositionModal from '@/components/modals/ClosePositionModal';

interface PositionData {
  coin: string;
  side: 'Long' | 'Short';
  size: number;
  entryPrice: number;
  markPrice: number;
  pnl: number;
  pnlPercent: number;
}

interface ModalContextType {
  openEstablishConnectionModal: () => void;
  closeEstablishConnectionModal: () => void;
  openClosePositionModal: (position: PositionData) => void;
  closeClosePositionModal: () => void;
}

const ModalContext = createContext<ModalContextType>({
  openEstablishConnectionModal: () => {},
  closeEstablishConnectionModal: () => {},
  openClosePositionModal: () => {},
  closeClosePositionModal: () => {},
});

export const useModal = () => useContext(ModalContext);

interface ModalProviderProps {
  children: ReactNode;
}

export function ModalProvider({ children }: ModalProviderProps) {
  const [isEstablishConnectionOpen, setIsEstablishConnectionOpen] = useState(false);
  const [isClosePositionOpen, setIsClosePositionOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState<PositionData | null>(null);

  const openEstablishConnectionModal = () => {
    setIsEstablishConnectionOpen(true);
  };

  const closeEstablishConnectionModal = () => {
    setIsEstablishConnectionOpen(false);
  };

  const openClosePositionModal = (position: PositionData) => {
    setSelectedPosition(position);
    setIsClosePositionOpen(true);
  };

  const closeClosePositionModal = () => {
    setIsClosePositionOpen(false);
    setSelectedPosition(null);
  };

  const handleClosePosition = (price: string, amount: string, isMarket: boolean) => {
    // TODO: Implement actual close position logic
    console.log('Closing position:', selectedPosition, 'at price:', price, 'amount:', amount, 'isMarket:', isMarket);
    closeClosePositionModal();
  };

  return (
    <ModalContext.Provider
      value={{
        openEstablishConnectionModal,
        closeEstablishConnectionModal,
        openClosePositionModal,
        closeClosePositionModal,
      }}
    >
      {children}

      {/* 모든 모달들은 여기서 관리 */}
      <EstablishConnectionModal
        isOpen={isEstablishConnectionOpen}
        onClose={closeEstablishConnectionModal}
      />

      {selectedPosition && (
        <ClosePositionModal
          isOpen={isClosePositionOpen}
          onClose={closeClosePositionModal}
          position={selectedPosition}
          onConfirm={handleClosePosition}
        />
      )}
    </ModalContext.Provider>
  );
}
